import {useSidebarStore} from './sidebar/sidebarStore';
import {Menu} from 'lucide-react';

export default function Header() {
  const toggleSidebar = useSidebarStore((state) => state.toggle);

  return (
    <header className="relative z-50 grid h-16 grid-cols-[1fr_auto_1fr] items-center border-b border-gray-200 bg-white px-6 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.15)]">
      <div className="flex min-w-0 items-center overflow-hidden">
        <button
          onClick={toggleSidebar}
          className="mr-4 flex-shrink-0 text-gray-500 hover:text-gray-700 focus:outline-none lg:hidden"
        >
          <Menu className="h-6 w-6" />
        </button>
        <div
          id="header-left-actions"
          className="flex min-w-0 flex-1 items-center"
        />
      </div>
      <div
        id="header-center-actions"
        className="flex items-center justify-center"
      />
      <div
        id="header-right-actions"
        className="flex min-w-0 items-center justify-end space-x-4"
      >
        {/* User Profile and Notifications moved to Sidebar */}
      </div>
    </header>
  );
}
